import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CreditcardIcon, MobilePhoneIcon, RefreshIcon } from '../../../../icons';
import { IconProps } from '../../../../icons/templates/icon';
import { CardRequestType } from '../../../../../queries/pxtraCard';

const typeIcons: Record<CardRequestType, FC<IconProps>> = {
  virtual_card: MobilePhoneIcon,
  physical_card: CreditcardIcon,
  replacement_card: RefreshIcon
};

export const RequestTypeCell: FC<{ type: CardRequestType }> = ({ type }) => {
  const { t } = useTranslation();
  const Icon = typeIcons[type];

  return (
    <Box className="flex items-center gap-2">
      <Icon color="grey.600" />
      <Typography variant="body2" className="whitespace-nowrap">
        {t(`pxtraCard:type_${type}`)}
      </Typography>
    </Box>
  );
};
